import { ArrayInput, Create, Edit, SimpleForm, SimpleFormIterator, TextInput } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";




export function MomentEdit() {
    return (
        <Edit>
            <SimpleForm>
                <TextInput source="name" />
                <RichTextInput source="description" />
                <ArrayInput source="tags">
                    <SimpleFormIterator>
                        <TextInput source="" />
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Edit>
    );
}